import React, { useCallback, useEffect } from 'react';

const ValuationForm = ({
  vehicleCategories = [],
  vehicleData,
  vehicleTerm,
  dealers,
  selectedDealerId,
  onDealerSelect,
  onSubmit,
  onBack,
  isSubmitting,
  mailSrc,
  scrapValueText = '',
  scrapMessage = '',
  pushToDataLayer,
}) => {
  const getScrapRange = () => {
    const selectedCategory = vehicleCategories.find(
      (cat) => cat.displayName === vehicleData.vehicleCategory
    );

    return selectedCategory?.fields?.Message?.value || '';
  };

  const handleDealerClick = useCallback(
    (dealer) => {
      onDealerSelect(dealer);

      pushToDataLayer({
        event: 'Enquiry_Form',
        eventCategory: 'Enquiry form',
        eventAction: dealer.wp_name, // Dealer name
        eventLabel: 'NA',
        FormType: 'ELV Form',
        State: vehicleData.state,
        City: vehicleData.city,
        Pincode: vehicleData.pincode,
        DealerName: dealer.wp_name,
        vehicle_type: vehicleData.vehicleType,
        section_name: 'Validation Details',
      });
    },
    [onDealerSelect, pushToDataLayer]
  );

  return (
    <form className="contact-form" onSubmit={onSubmit}>
      <div className="form-scroll">
        <h3 className="valuation-heading">{scrapValueText}</h3>
        <div className="valuation-banner">
          {scrapMessage}
          <span className="valuation-amount">{getScrapRange()}</span>

          <span className="star-tooltip">
            *<span className="tooltip-text">{vehicleTerm}</span>
          </span>
        </div>

        <h4 className="dealer-heading">
          {`Dealers at ${vehicleData.city} for ${vehicleData.vehicleType}`}
        </h4>

        {dealers.length > 0 ? (
          <div className="dealer-list">
            {dealers.map((dealer, index) => (
              <div
                key={dealer.dealer_id || index}
                className={`dealer-card ${
                  selectedDealerId === dealer.dealer_id ? 'dealer-card--primary active' : ''
                }`}
                onClick={() => handleDealerClick(dealer)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && handleDealerClick(dealer)}
              >
                <div className="dealer-title">{dealer.wp_name}</div>
                <div className="dealer-address">{dealer.address}</div>
                {dealer.email_id && (
                  <div className="dealer-email">
                    <img src={mailSrc} alt="email" />
                    <span>{dealer.email_id}</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="no-dealers-message">No dealers available for the selected location.</p>
        )}
      </div>
      <div className="form-actions">
        <button type="button" className="button-secondary" onClick={onBack}>
          Back
        </button>
        <button
          type="submit"
          className={`button-primary ${selectedDealerId ? 'enabled' : ''}`}
          disabled={!selectedDealerId || isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    </form>
  );
};

export default ValuationForm;
